export default () => {
    // Use pre-calculated values from inline script (set after header renders)
    // Fall back to calculating if not available
    const header = document.getElementById('site-header');
    const alertBar = document.getElementById('alert-bar');

    return {
        navIsOpen: false,
        headerHeight: window.__headerHeight ?? (header ? header.offsetHeight : 136),
        screenWidth: window.innerWidth,
        isMobile: window.innerWidth < 1024,
        alertbarHeight: window.__alertbarHeight ?? (alertBar ? alertBar.offsetHeight : 0),

        init() {
            // Recalculate to ensure accuracy
            const headerEl = document.getElementById('site-header');
            this.headerHeight = headerEl ? headerEl.offsetHeight : 136;
            this.screenWidth = window.innerWidth;
            this.setIsMobile();
            this.setAlertBarHeight();
            this.attachSubmenuListeners();

            //remove class !max-h-0 or !max-h-full from #site-header-animated-panel -- these classes are there to prevent the flash on page load
            const animatedPanel = document.getElementById('site-header-animated-panel');
            this.$nextTick(() => {
                animatedPanel.classList.remove('!max-h-0', '!max-h-full', '!transition-none');
            });

            // Listen for window resize to update screenWidth and isMobile
            window.addEventListener('resize', () => {
                this.screenWidth = window.innerWidth;
                this.setIsMobile();
                const header = document.getElementById('site-header');
                this.headerHeight = header ? header.offsetHeight : 136;
                this.setAlertBarHeight();
                // Update main content margin on resize
                this.updateContentMargin();
            });
        },
        setIsMobile() {
            this.isMobile = this.screenWidth < 1024;
        },
        setAlertBarHeight() {
            // if the alert bar exists on the page, get its height
            const alertBar = document.getElementById('alert-bar');
            if (alertBar) {
                this.alertbarHeight = alertBar.offsetHeight;
                // Also update CSS custom property for non-Alpine components
                document.documentElement.style.setProperty('--alertbar-height', this.alertbarHeight + 'px');
            }
        },
        updateContentMargin() {
            // Update main content margin for home/suites pages
            const mainContent = document.getElementById('content');
            if (mainContent && document.body.classList.contains('home')) {
                const margin = -(this.headerHeight - this.alertbarHeight);
                mainContent.style.marginTop = margin + 'px';
            }
        },
        attachSubmenuListeners() {
            const triggerElements = this.$el.querySelectorAll('.can-trigger-header-animation');
            const animatedPanel = document.getElementById('site-header-animated-panel');

            triggerElements.forEach((li) => {
                const submenu = li.querySelector('.submenu');

                if (submenu) {
                    // mouseenter
                    li.addEventListener('mouseenter', () => {
                        const submenuHeight = submenu.offsetHeight;
                        const totalHeight = this.headerHeight + submenuHeight + 90;
                        animatedPanel.style.maxHeight = `${totalHeight}px`;
                    });

                    // mouseleave
                    li.addEventListener('mouseleave', () => {
                        const isHome = animatedPanel.classList.contains('is-home');
                        animatedPanel.style.maxHeight = isHome ? '0px' : `${this.headerHeight}px`;
                    });
                }
            });
        }
    };
};
